var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("You killed an innocent member! The Oddball is still at large!")]),_c('router-link',{attrs:{"to":"/statements"}},[_c('b-button',{staticClass:"next-button"},[_vm._v("Back to Statement Round")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }